import React from 'react';
import PropTypes from 'prop-types';
import Dotdotdot from 'react-dotdotdot';
import { Link } from 'react-router';
import Badge from 'components/Badge';
import PlayButton from 'components/Tile/components/PlayButton';
import FavoriteLink from '../../../FavoriteLink';
import style from './style.css';

const HoverOverlay = ({
  badge,
  description,
  favoriteData,
  favoritesManager,
  metadata,
  network,
  networkLogoUrl,
  onTitleClick,
  playButtonText,
  showPlayButton,
  subtitle,
  theme,
  title,
  titleLink,
  upcomingDate,
}) => {
  const favoriteProps = {
    favoriteData,
    favoritesManager,
    theme,
  };
  const titleDisplay = titleLink ? (
    <Link onClick={onTitleClick} to={titleLink}>
      {title}
    </Link>
  ) : (
    title
  );
  return (
    <div className={style.hoverOverlay}>
      <div className={style.innerContainer}>
        <div className={style.detailContainer}>
          <Badge theme={{ ...theme, ...style }} badge={badge} />
          <div className={style.date}>{upcomingDate}</div>
          <div className={style.title}>
            {titleDisplay}
            {!upcomingDate && (
              <span className={style.titleFavorite}>
                <FavoriteLink {...favoriteProps} />
              </span>
            )}
          </div>
          {subtitle && <div className={style.subtitle}>{subtitle}</div>}
          <div className={style.description}>
            <Dotdotdot clamp={2}>{description}</Dotdotdot>
          </div>
        </div>
        <div className={style.footer}>
          <div>
            {!!networkLogoUrl && (
              <img alt={network} className={style.networkLogo} src={networkLogoUrl} />
            )}
            {metadata && <span className={style.metadata}>{metadata}</span>}
          </div>
          {showPlayButton && <PlayButton text={playButtonText} theme={style} />}
          <div>{upcomingDate && <FavoriteLink {...favoriteProps} withLabel />}</div>
        </div>
      </div>
    </div>
  );
};

export default HoverOverlay;

HoverOverlay.defaultProps = {
  badge: null,
  description: null,
  favoriteData: null,
  favoritesManager: null,
  metadata: null,
  network: null,
  networkLogoUrl: null,
  onTitleClick: () => {},
  playButtonText: null,
  showPlayButton: true,
  subtitle: null,
  theme: {},
  title: null,
  titleLink: null,
  upcomingDate: null,
};

HoverOverlay.propTypes = {
  badge: PropTypes.string,
  description: PropTypes.string,
  favoriteData: PropTypes.shape({}),
  favoritesManager: PropTypes.shape({}),
  metadata: PropTypes.string,
  network: PropTypes.string,
  networkLogoUrl: PropTypes.string,
  onTitleClick: PropTypes.func,
  playButtonText: PropTypes.string,
  showPlayButton: PropTypes.bool,
  subtitle: PropTypes.string,
  theme: PropTypes.shape({}),
  title: PropTypes.string,
  titleLink: PropTypes.string,
  upcomingDate: PropTypes.string,
};
